import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import SurveyQuestions from "./SurveyList/SurveyQuestions";
import SurveyRespondents from "./SurveyList/SurveyRespondents";
import SurveyTimeVariable from "./SurveyList/SurveyTimeVariable";

const FilteredSurveys = (props) => {
  const {
    client,
    setToast,
    SurveysList,
    totalQuestionsAndRespondents,
    surveyStatus,
  } = props;

  const getStatus = (statusId) => {
    return (
      surveyStatus
        ?.find((item) => item.id === statusId)
        ?.value?.toLowerCase() || ""
    );
  };

  return (
    <Fragment>
      {SurveysList?.map((campaign) => {
        const campaignStatus = getStatus(campaign.statusId);

        return (
          <div className="column _25" key={campaign.campaignRef}>
            <Link
              to={
                campaignStatus === "draft"
                  ? `/dashboard/ask/new-survey/${campaign.campaignRef}`
                  : `/dashboard/ask/survey/${campaign.campaignRef}`
              }
              className="card-2 active w-inline-block"
            >
              <div
                className={`card-marker ${
                  campaignStatus === "draft"
                    ? "pink"
                    : campaignStatus === "live"
                    ? "active"
                    : campaignStatus === "finished"
                    ? "blue"
                    : "important"
                }`}
              ></div>
              <div className="card-section vertical padded">
                <div
                  className={`chip ${
                    campaignStatus === "draft"
                      ? "pink"
                      : campaignStatus === "live"
                      ? "primary"
                      : campaignStatus === "finished"
                      ? "blue"
                      : "important"
                  }`}
                >
                  {campaignStatus}
                </div>
                <div className="data move-down">{campaign.campaignName}</div>
                <SurveyTimeVariable
                  campaign={campaign}
                  surveyStatus={surveyStatus}
                />
              </div>
              <div className="row">
                <div className="card-section expand padded">
                  <SurveyQuestions
                    client={client}
                    setToast={setToast}
                    campaignRef={campaign.campaignRef}
                    totalQuestionsAndRespondents={totalQuestionsAndRespondents}
                  />
                  <SurveyRespondents
                    client={client}
                    setToast={setToast}
                    campaignRef={campaign.campaignRef}
                    numberOfRespondents={campaign.numberOfRespondents}
                    totalQuestionsAndRespondents={totalQuestionsAndRespondents}
                  />
                  <div className="bar-container">
                    <div className="measure-bar short">
                      <div
                        className="metric primary _0"
                        style={{ height: "7.99219px" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row"></div>
            </Link>
          </div>
        );
      })}
    </Fragment>
  );
};

export default FilteredSurveys;
